import React from 'react';
import { Link } from 'react-router-dom';
import './foundation-olympiad.css';

const highlights = [
  {
    icon: 'school',
    title: 'Exam-Oriented Specially Designed Batches',
    description: 'Curated programs specifically for students of Classes 8th, 9th, and 10th.',
  },
  {
    icon: 'emoji_objects',
    title: 'Learning Outcomes',
    description: 'Strong core fundamentals, advanced problem-solving skills, and learning bridge to higher competitive levels.',
  },
  {
    icon: 'co_present',
    title: 'Teaching Mode',
    description: 'Choice of interactive Classroom sessions, Live Online classes, or flexible Hybrid models.',
  },
];

const curriculum = [
  {
    title: 'Science (Physics, Chemistry, Biology)',
    icon: 'science',
  },
  {
    title: 'Mathematics',
    icon: 'calculate',
  },
];

const advantages = [
  {
    icon: 'emoji_events',
    title: 'Early Exposure',
    description: 'Introduction to competitive formats early on to build confidence and exam temperament.',
  },
  {
    icon: 'diversity_1',
    title: 'Personal Attention',
    description: 'Small batch sizes ensuring every student gets the individual guidance they need.',
  },
  {
    icon: 'psychology',
    title: 'Concept Clarity',
    description: 'Focus on deep understanding and application rather than rote learning.',
  },
  {
    icon: 'insights',
    title: 'Performance Feedback',
    description: 'Regular assessments and detailed feedback loops to track progress and improvement.',
  },
];

const FoundationOlympiad: React.FC = () => {
  const guidanceFormUrl = "https://forms.gle/xdExtHf2Yss4ZaHq9";
  const brochureUrl = "https://drive.google.com/file/d/1l5rloH-eS_x0pKcriMMPvX-Mg5DIixDU/view?pli=1";
  return (
    <div className="fo-page">
      {/* Tabs */}
      <div className="fo-container">
        <Link className="fo-back-link" to="/courses" aria-label="Back to Courses">
          <span className="material-symbols-outlined">arrow_back</span>
          <span>Back to Courses</span>
        </Link>

        <div className="fo-tabs">
          <Link className="fo-tab is-active" to="/courses/foundation-olympiad">
            Foundation (8th-10th)
          </Link>
          <Link className="fo-tab" to="/courses/olympiad">
            Olympiad (8th-12th)
          </Link>
        </div>

        {/* Hero */}
        <section className="fo-hero">
          <div className="fo-hero__overlay" />
          <div className="fo-hero__content">
            <span className="fo-badge">
              <span className="material-symbols-outlined">school</span>
              FOUNDATION WING
            </span>

            <h1 className="fo-hero__title">
              Foundation Courses:
              <br />
              Building a Solid Academic
              <br />
              Base
            </h1>

            <p className="fo-hero__subtitle">
              Strengthening core concepts in Science and Mathematics to prepare students for higher classes and competitive excellence.
            </p>
            <p className="fo-safalta-text">
              📘 Foundations – Safalta (सफलता)
              <br />
              Where young minds are shaped early — for lifelong success 🌟
            </p>

            <div className="fo-hero__actions">
              <a className="fo-btn fo-btn--primary" href={guidanceFormUrl} target="_blank" rel="noopener noreferrer">
                Register for Career Guidance
              </a>
              <Link className="fo-btn fo-btn--secondary" to="/our-students">
                View Success Stories
              </Link>
            </div>
          </div>
        </section>

        {/* Highlights */}
        <section className="fo-section">
          <h2 className="fo-section__title">Course Highlights</h2>

          <div className="fo-grid fo-grid--3">
            {highlights.map((item) => (
              <article className="fo-card" key={item.title}>
                <div className="fo-card__icon">
                  <span className="material-symbols-outlined">{item.icon}</span>
                </div>
                <h3 className="fo-card__title">{item.title}</h3>
                <p className="fo-card__text">{item.description}</p>
              </article>
            ))}
          </div>
        </section>

        {/* Curriculum */}
        <section className="fo-section fo-section--spaced">
          <div className="fo-section__head">
            <div>
              <h2 className="fo-section__title">Curriculum</h2>
              <p className="fo-section__subtitle">Holistic coverage of Science and Mathematics for school and competitions.</p>
            </div>
            <a className="fo-link" href={brochureUrl} target="_blank" rel="noopener noreferrer">
              Download Brochure
            </a>
          </div>

          <div className="fo-accordion">
            {curriculum.map((c) => (
              <details className="fo-accordion__item" key={c.title}>
                <summary className="fo-accordion__summary">
                  <span className="fo-accordion__left">
                    <span className="material-symbols-outlined">{c.icon}</span>
                    {c.title}
                  </span>
                  <span className="material-symbols-outlined fo-accordion__chev">expand_more</span>
                </summary>

                <div className="fo-accordion__body">
                  <p>Detailed module breakup will be shared in the onboarding session.</p>
                </div>
              </details>
            ))}
          </div>

          <div className="fo-note">
            <span className="material-symbols-outlined">workspace_premium</span>
            <div>
              <strong>Program Includes:</strong> Complete Mentorship for school exams plus a strong foundation for future competitive exams.
            </div>
          </div>
        </section>

        {/* Advantage */}
        <section className="fo-section fo-section--spaced">
          <h2 className="fo-section__title">The S-CUBUS Advantage</h2>

          <div className="fo-grid fo-grid--2">
            {advantages.map((a) => (
              <article className="fo-adv" key={a.title}>
                <div className="fo-adv__icon">
                  <span className="material-symbols-outlined">{a.icon}</span>
                </div>
                <div>
                  <h3 className="fo-adv__title">{a.title}</h3>
                  <p className="fo-adv__text">{a.description}</p>
                </div>
              </article>
            ))}
          </div>
        </section>

        {/* CTA */}
        <section className="fo-cta">
          <div className="fo-cta__content">
            <h2 className="fo-cta__title">Start Early, Stay Ahead!</h2>
            <p className="fo-cta__text">Join our Foundation program today and pave the way for academic excellence.</p>
          </div>

          <div className="fo-cta__actions">
            <a className="fo-btn fo-btn--primary" href={guidanceFormUrl} target="_blank" rel="noopener noreferrer">
              Register for Career Guidance
            </a>
            <a className="fo-btn fo-btn--ghost" href={brochureUrl} target="_blank" rel="noopener noreferrer">
              <span className="material-symbols-outlined">download</span>
              Program Brochure
            </a>
          </div>
        </section>
      </div>
    </div>
  );
};

export default FoundationOlympiad;
